import { apiService } from '../services';

export const getThumbUrl = (url: string | undefined): string => {
  if (!url) {
    return '';
  }

  return `${apiService.baseFilePath}/${url}`;
};